import { wrapUseRoutes } from '@sentry/react';
import { Navigate, useRoutes } from 'react-router-dom';
import { NavbarLayout } from '~pages/[organization]/_layout';
import { LandingPage } from '~pages/Landing';

const useSentryRoutes = wrapUseRoutes(useRoutes);

export function AppRoutes() {
  const element = useSentryRoutes([
    {
      path: '/',
      element: <NavbarLayout />,
      children: [
        {
          index: true,
          element: <LandingPage />,
        },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/" replace />,
    },
  ]);

  return element;
}
